import { Properties } from '@databases/collab/y-database';
import { type StructuralChange } from '@databases/selections';
import { type CollabManager } from '@databases/utils/redux/collab/collab-manager';
import type * as Y from 'yjs';

export function createCollabStructuralChangeSubscription(
  collabManager: CollabManager
): (onChange: (change: StructuralChange) => void) => VoidFunction {
  return (onChange) => {
    let prevEntries = collabManager.database.entries;
    let prevFields = collabManager.database.fields;

    const doc = collabManager.database.doc;
    const entriesArray = doc.getArray(Properties.entries);
    const fieldsArray = doc.getArray(Properties.fields);

    const handler = (_events: Y.YEvent<any>[], transaction: Y.Transaction) => {
      const nextEntries = collabManager.database.entries;
      const nextFields = collabManager.database.fields;

      // Only notify for remote changes. Local mutations already update the UI; dispatching
      // reconcileSelections here would be redundant and would cause double updates
      if (!transaction.local) {
        onChange({
          entries: { prev: prevEntries, next: nextEntries },
          fields: { prev: prevFields, next: nextFields },
        });
      }

      prevEntries = nextEntries;
      prevFields = nextFields;
    };

    entriesArray.observeDeep(handler);
    fieldsArray.observeDeep(handler);

    return () => {
      entriesArray.unobserveDeep(handler);
      fieldsArray.unobserveDeep(handler);
    };
  };
}
